module.exports = __webpack_public_path__ + "img/sage-collective_banner.69df7671.jpg";